var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResBloodPressure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 29.607c0 16.352-13.88 29.607-31 29.607-17.12 0-31-13.255-31-29.607C2 13.255 15.88 0 33 0c17.12 0 31 13.255 31 29.607",
    fill: "#F4E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 65c-8.748 0-16.943-3.298-23.074-9.287a1.342 1.342 0 0 1-.034-1.88 1.3 1.3 0 0 1 1.854-.034c5.64 5.51 13.188 8.544 21.254 8.544 8.046 0 15.579-3.02 21.214-8.503a1.297 1.297 0 0 1 1.854.037c.502.53.484 1.372-.039 1.88C49.905 61.717 41.726 65 33 65",
    fill: "#C63DE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.456 16.022c-5.772 0-10.687 3.714-12.548 8.913-1.86-5.2-6.776-8.913-12.546-8.913-7.371 0-14.011 7.742-14.011 15.211-.09 2.598-.092 13.366 16.048 26.234a32.23 32.23 0 0 0 10.503 1.747c3.545 0 6.947-.576 10.12-1.622l.33-.231c15.445-11.836 16.045-23.377 16.114-26.128 0-7.47-6.64-15.21-14.01-15.21",
    fill: "#C63DE8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m28.234 54.022-3.59-11.725H6.695v-4.834H28.16l1.752 5.73 9.277-13.38 5.359 9.3h13.97v4.835H41.808l-2.99-5.192z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResBloodPressure);
export default __webpack_public_path__ + "static/media/resBloodPressure.7f75ff7a9af32380df6ef0b6b969d0be.svg";
export { ForwardRef as ReactComponent };